import React, { useState } from "react";
import "./styles.css";

import { useRef } from "react";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";

import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../../Context/Context";
import { use, useContext, useEffect } from "react";
import {
  getRecords,
  PostRecords,
  uploadMultipleFiles,
} from "../../Services/ApiCall";
import FeaturedProperty from "../../Common/FeaturedProperties";
import ProjectsComp from "../../Common/Projects";
import NearByProperties from "../../Common/NearByProperties";
import {
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  BaseUrl,
  apiUrl_dialerp,
  setLogindata,
  setUserdata,
} from "../../Services/Urls";
import FilterParams from "../../Classes/FilterParams";
import { useNavigate } from "react-router-dom";

import { TailSpin } from "react-loader-spinner";
import SelectDialog from "../../Common/SelectDialog ";
import AmenitiesDialog from "../../Common/AmenitiesDialog";
import { decryptOtp } from "../../Services/Helper";
import {
  callApi,
  makeApiRequest,
  callAzureOpenAI,
} from "../../Services/ApiService";

import { toast } from "react-toastify";
import SucessDialog from "../../Common/Dialog/SucessDialog";
import {
  formatIndianAmount,
  removeSpecialCharacters,
} from "../../Services/Helper";

export default function AdDashborad() {
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    CityData,

    coordinates,

    Locality,

    Area,
  } = useContext(ApiContext);

  const navigate = useNavigate();

  const [showDetails, setShowDetails] = useState(false);
  const [campaigns, setcampaigns] = useState([]);

  const [Active, setActive] = useState(0);
  const [TotalImpressions, setTotalImpressions] = useState(0);
  const [TotalLeads, setTotalLeads] = useState(0);
  const [TotalViews, setTotalViews] = useState(0);
  const [TotalSpent, setTotalSpent] = useState(0.0);

  const [isEdit, setisEdit] = useState(false);
  const [CampaignID, setCampaignID] = useState(null);
  const [CampaignData, setCampaignData] = useState(null);
  const [budget, setBudget] = useState(0);
  const [loading, setloading] = useState(false);
  const costPerImpression = 1.4;

  const quickBudgets = [500, 1000, 2500, 5000];

  const formatDate = (date) =>
    new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);

  const calculateDays = (start, end) => {
    if (!start || !end) return 0;

    const s = new Date(start);
    const e = new Date(end);

    const diffTime = e - s;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    return diffDays >= 0 ? diffDays + 1 : 0; // +1 to include start day
  };

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const totalDays = calculateDays(startDate, endDate);
  const totalBudget = totalDays * Number(budget || 0);

  const impressions = Math.round(totalBudget / costPerImpression);

  useEffect(() => {
    getCampaignsData();
    getwalletdetails();
  }, []);

  const getCampaignsData = () => {
    const filter = `{UserID: { $in: [${LoggedInUserID}] }}`;
    getRecords(431, 1000, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false) {
          setcampaigns(data?.response?.records || []);

          if (data?.response?.records?.length > 0) {
            let Active = 0;
            let TotalImpressions = 0;
            let TotalLeads = 0;
            let TotalViews = 0;
            let TotalSpent = 0;

            data?.response?.records?.forEach((element) => {
              TotalImpressions += element?.TotalImpressions || 0;
              TotalLeads += element?.TotalLeads || 0;
              TotalViews += element?.TotalViews || 0;
              TotalSpent += Number(element?.SpentAmount || 0);
            });
            setActive(data?.response?.records?.length);
            setTotalImpressions(TotalImpressions);
            setTotalLeads(TotalLeads);
            setTotalViews(TotalViews);
            setTotalSpent(Number(TotalSpent.toFixed(2)));
          }
        } else {
          console.log("Error in fetching featured properties", data);
        }
      }
    });
  };

  const PauseCampaign = (data) => {
    const updatebody = [
      {
        CampaignID: data?.CampaignID,
        StatusID: data?.StatusID == 1 ? 2 : 1,
        Status: data?.StatusID == 1 ? "Paused" : "Active",
      },
    ];
    PostRecords(431, 1, updatebody, (data) => {
      if (data != null && data?.response?.hasErrors === false) {
        toast.success(`${"Campaign Paused Successfully"}`);
        getCampaignsData();
      } else {
        toast.error(`${data?.response?.errors}`);
      }
    });
  };

  const getwalletdetails = () => {
    const filter = `{UserID: { $in: [${LoggedInUserID}] }}`;

    getRecords(437, 1, filter, 1, "", (data) => {
      if (data != null) {
        if (data?.hasErrors === false && data?.response?.records != null) {
          setwalletData(data?.response?.records[0] || null);
          setloading(false);
        } else {
          setwalletData(null);
          setloading(false);
          console.log("Error in fetching featured properties", data);
        }
      } else {
        setloading(false);
      }
    });
  };

  const [walletData, setwalletData] = useState(null);

  const handleEditCampaign = (data, flag) => {
    if (flag == 1) {
      setisEdit(true);
      setCampaignID(data?.CampaignID);
      setCampaignData(data);
      setShowDetails(!showDetails);
      setBudget(data?.DailyBudget);
      setStartDate(data?.StartDate);
      setEndDate(data?.EndDate);
    } else {
      setisEdit(false);
      setCampaignID(data?.CampaignID);
      setShowDetails(!showDetails);
    }
  };

  const handleCancel = () => {
    setisEdit(false);
    setCampaignID(null);
    setShowDetails(!showDetails);
    setCampaignData(null);
  };

  const handleUpdateCampaign = () => {
    const body = [
      {
        CampaignID: CampaignID,

        Budget: totalBudget,

        StartDate: startDate,
        EndDate: endDate,

        DailyBudget: budget,
      },
    ];
    console.log("walletData?.Balance", walletData?.Balance);

    console.log(
      "Math.abs(totalBudget - walletData?.Balance)",
      Math.abs(totalBudget - CampaignData?.Budget),
    );

    if (walletData?.Balance < Math.abs(totalBudget - CampaignData?.Budget)) {
      toast.error("Insufficient wallet Balance");
      navigate("/wallet");
    } else {
      PostRecords(431, 1, body, (data) => {
        if (data != null && data?.response?.hasErrors === false) {
          const walletbody = [
            {
              WalletID: walletData?.WalletID,

              Balance:
                parseFloat(walletData?.Balance || "0") -
                parseFloat(Math.abs(totalBudget - CampaignData?.Budget) || "0"),
              TotalDebited:
                parseFloat(walletData?.TotalDebited || "0") +
                parseFloat(Math.abs(totalBudget - CampaignData?.Budget) || "0"),
            },
          ];

          PostRecords(437, 1, walletbody, (data) => {
            if (data != null && data?.response?.hasErrors === false) {
              const TransationBody = [
                {
                  User: userData?.User,
                  UserID: userData?.UserID,
                  Amount: Math.abs(totalBudget - CampaignData?.Budget),
                  BalanceAfter:
                    parseFloat(walletData?.Balance || "0") -
                    parseFloat(
                      Math.abs(totalBudget - CampaignData?.Budget) || "0",
                    ),
                  CampaignID: CampaignID || 0,
                  Campaign: CampaignData?.Campaign || "",
                },
              ];

              PostRecords(438, 1, TransationBody, (data) => {
                if (data != null && data?.response?.hasErrors === false) {
                  toast.success(`${"Campaign Updated Successfully"}`);

                  handleCancel();
                  getCampaignsData();
                  getwalletdetails();
                  //setStep(1);
                  // getMyListingData();
                  //setShowModal(true);
                } else {
                  toast.error(`${data?.response?.errors}`);
                }
              });
            } else {
              toast.error(`${data?.response?.errors}`);
            }
          });
        } else {
          toast.error(`${data?.response?.errors}`);
        }
      });
    }
  };

  return (
    <div className="container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span className="light">LandPanda Ads</span>
        <span className="arrow">›</span>
        <span className="bold"> Campaigns</span>
      </div>

      {/* Stats */}
      <div className="stats">
        <div className="statCard">
          <div className="statHeader">
            <span>Active</span>
            <span className="icon green">
              <i class="ri-rocket-2-line"></i>
            </span>
          </div>
          <div className="statValue">{Active}</div>
        </div>

        <div className="statCard">
          <div className="statHeader">
            <span>Impressions</span>
            <span className="icon blue">
              <i class="ri-eye-line"></i>
            </span>
          </div>
          <div className="statValue">{TotalImpressions}</div>
        </div>

        <div className="statCard">
          <div className="statHeader">
            <span>Leads</span>
            <span className="icon purple">
              <i class="ri-user-add-line"></i>
            </span>
          </div>
          <div className="statValue">{TotalLeads}</div>
        </div>

        <div className="statCard">
          <div className="statHeader">
            <span>Spent</span>
            <span className="icon orange">
              <i class="ri-money-rupee-circle-line"></i>
            </span>
          </div>
          <div className="statValue">{TotalSpent} Credits</div>
        </div>
      </div>

      {/* Campaign Card */}

      {campaigns?.map((item, index) => {
        const defaultImage = "assets/img/property/property-22.jpg";

        const imageSrc =
          typeof item?.Images === "string" && item?.Images.trim() !== ""
            ? item?.Images.split(",")[0].trim()
            : defaultImage;

        return (
          <div className="campblock">
            <div className="campaignCard">
              <img className="campaignImage" src={imageSrc} alt="" />

              <div className="campaignInfo">
                <div className="campaignTop">
                  <div className="campaignTitle">
                    
                    <div>{item?.Campaign}    <div className="status">
                    <i class="ri-play-circle-fill"></i> {item?.Status}
                  </div>   </div> 
                    
                    <div className="buttons">
                  <button
                    onClick={() => PauseCampaign(item)}
                    className="pauseBtn"
                  >
                    {" "}
                    {item?.StatusID == 1 ? "❚❚ Pause" : "Resume"}
                  </button>

                  <button
                    className="detailBtn"
                    onClick={() => handleEditCampaign(item, 1)}
                  >
                    <i class="ri-arrow-drop-down-line"></i> Edit
                  </button>

                  <button
                    className="detailBtn"
                    onClick={() => handleEditCampaign(item, 2)}
                  >
                    <i class="ri-arrow-drop-down-line"></i> Details
                  </button>
                </div>
                
                </div>

                
                </div>

                <div className="campaignSub">{item?.Title}</div>

                <div className="location">
                  <i class="ri-map-pin-line"></i> {item?.Locality}
                </div>

           

                <div className="metrics">
                  <div>
                    <div className="metricLabel">Budget</div>
                    <div className="metricValue">₹{item?.Budget}</div>
                  </div>

                  <div>
                    <div className="metricLabel">Impressions</div>
                    <div className="metricValue">{item?.TotalImpressions}</div>
                  </div>

                  <div>
                    <div className="metricLabel">Views</div>
                    <div className="metricValue">{item?.TotalViews}</div>
                  </div>

                  <div>
                    <div className="metricLabel">Leads</div>
                    <div className="metricValue greenText">
                      {item?.TotalLeads}
                    </div>
                  </div>
                </div>

                <div className="spent">
                  {" "}
                  Spent: ₹{Number(item?.SpentAmount || 0).toFixed(2)}
                </div>

                <div className="progressBar">
                  <div className="progress"></div>
                </div>
              </div>
            </div>

            {/* DETAILS PANEL */}
            {showDetails && CampaignID == item?.CampaignID && (
              <div className="detailsPanel">
                <div className="details-wrapper">
                  {!isEdit ? (
                    <>
                      <h2 className="details-title">
                        Campaign Performance Details
                      </h2>

                      <div className="details-grid">
                        <div className="details-card">
                          <div className="card-label">
                            Click-Through Rate (CTR)
                          </div>
                          <div className="card-value">14.47%</div>
                          <div className="card-sub">
                            412 views from 2847 impressions
                          </div>
                        </div>

                        <div className="details-card">
                          <div className="card-label">Conversion Rate</div>
                          <div className="card-value">5.58%</div>
                          <div className="card-sub">
                            23 leads from 412 views
                          </div>
                        </div>

                        <div className="details-card">
                          <div className="card-label">Cost Per Lead</div>
                          <div className="card-value">₹173.30</div>
                          <div className="card-sub">
                            Average cost per lead generated
                          </div>
                        </div>
                      </div>

                      <div className="details-grid">
                        <div className="details-card">
                          <div className="card-label">Start Date</div>
                          <div className="card-value-small">15 Mar 2024</div>
                        </div>

                        <div className="details-card">
                          <div className="card-label">End Date</div>
                          <div className="card-value-small">Ongoing</div>
                        </div>

                        <div className="details-card">
                          <div className="card-label">Cost Per Impression</div>
                          <div className="card-value-small">₹1.40</div>
                        </div>
                      </div>

                      <div className="funnel-card">
                        <div className="funnel-title">Campaign Funnel</div>

                        <div className="funnel-row">
                          <div className="funnel-item">
                            <div className="funnel-header">
                              <span>Impressions</span>
                              <span>2,847</span>
                            </div>
                            <div className="bar-container">
                              <div className="bar blue"></div>
                            </div>
                          </div>

                          <div className="arrow">→</div>

                          <div className="funnel-item">
                            <div className="funnel-header">
                              <span>Views</span>
                              <span>412</span>
                            </div>
                            <div className="bar-container">
                              <div className="bar purple"></div>
                            </div>
                          </div>

                          <div className="arrow">→</div>

                          <div className="funnel-item">
                            <div className="funnel-header">
                              <span>Leads</span>
                              <span>23</span>
                            </div>
                            <div className="bar-container">
                              <div className="bar green"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <h2 className="details-title">Edit Campaign Details</h2>

                      <h2>Set Your Dialy Budget & Schedule</h2>
                      <p className="subtitle">
                        Choose how much you want to spend and when to run this
                        campaign
                      </p>

                      <div className="budget-wrapper">
                        {/* Budget Card */}

                        <div className="budget-card">
                          <p className="section-title">Quick Select</p>

                          <div className="quick-select">
                            {quickBudgets.map((b) => (
                              <button
                                key={b}
                                className={`quick-btn ${budget === b ? "active" : ""}`}
                                onClick={() => setBudget(b)}
                              >
                                ₹{b.toLocaleString()}
                              </button>
                            ))}
                          </div>

                          <h6>Daily Budget</h6>

                          <input
                            type="text"
                            className="text-input"
                            placeholder="Enter your daily budget"
                            value={budget}
                            onChange={(e) => setBudget(e.target.value)}
                          />

                          <div className="custom-budget">
                            <div className="budget-row">
                              <p>Custom Daily Budget</p>

                              <h3>₹{budget.toLocaleString()}</h3>
                            </div>

                            <input
                              type="range"
                              min="100"
                              max="10000"
                              value={budget}
                              onChange={(e) => setBudget(e.target.value)}
                              className="slider"
                            />

                            <div className="range-labels">
                              <span>₹100</span>
                              <span>₹10,000</span>
                            </div>
                          </div>

                          {/* Cost Box */}
                        </div>

                        {/* Schedule */}

                        <div className="schedule-card">
                          <h4>Campaign Schedule</h4>
                          <p className="subtitle-small">
                            Select the start and end dates for your campaign
                          </p>

                          <div className="date-grid">
                            <div className="date-field">
                              <label>Start Date</label>
                              <input
                                value={
                                  startDate
                                    ? new Date(startDate).toLocaleDateString(
                                        "en-CA",
                                      ) // YYYY-MM-DD
                                    : ""
                                }
                                onChange={(e) => {
                                  setStartDate(
                                    formatDate(new Date(e.target.value)),
                                  );
                                }}
                                type="date"
                              />
                            </div>

                            <div className="date-field">
                              <label>End Date</label>
                              <input
                                value={
                                  endDate
                                    ? new Date(endDate).toLocaleDateString(
                                        "en-CA",
                                      ) // YYYY-MM-DD
                                    : ""
                                }
                                onChange={(e) => {
                                  setEndDate(
                                    formatDate(new Date(e.target.value)),
                                  );
                                }}
                                type="date"
                              />
                              <p className="hint">Select a start date first</p>
                            </div>
                          </div>
                          <div className="cost-box">
                            <div className="cost-left">
                              <p>Cost per Impression</p>
                              <p>Total Days</p>
                              <p>Total Budget</p>
                              <strong>Estimated Impressions</strong>
                            </div>

                            <div className="cost-right">
                              <p style={{ color: "#000" }}>
                                ₹{costPerImpression.toFixed(2)}
                              </p>
                              <p style={{ color: "#000" }}>
                                {totalDays ? `${totalDays} days` : "0 days"}
                              </p>
                              <p style={{ color: "#000" }}>
                                ₹{totalBudget.toFixed(2)}
                              </p>
                              <strong>~{impressions}</strong>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="nav">
                        <button
                          className="back-btn"
                          onClick={() => handleCancel()}
                        >
                          Cancel
                        </button>
                        <button
                          disabled={!budget || !startDate || !endDate}
                          className="primary-btn"
                          style={{
                            backgroundColor:
                              !budget || !startDate || !endDate
                                ? "lightgrey"
                                : "",
                            color: "#fff",
                          }}
                          onClick={() => {
                            handleUpdateCampaign();
                          }}
                        >
                          Update
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
